import React from 'react';

/** Ô mã Authenticator 6 số, cùng kiểu các hộp step-up trong trang admin Hợp tác creator. */
const AdminTotpInput: React.FC<{ value: string; onChange: (v: string) => void }> = ({ value, onChange }) => (
  <label className="block text-sm font-medium text-slate-700 dark:text-slate-200">
    Mã Authenticator (6 số) <span className="text-red-500">*</span>
    <input
      aria-label="Mã Authenticator"
      value={value}
      onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
      placeholder="123456"
      inputMode="numeric"
      className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-center text-lg tracking-[0.3em] outline-none focus:border-[#0057FF] dark:border-slate-600 dark:bg-slate-900 dark:text-white"
    />
  </label>
);

export default AdminTotpInput;
